import { useState, useEffect } from 'react';
import { Handshake, CalendarClock, Gauge } from 'lucide-react';
import api from '../../lib/api';

const barColor = (pct) => (pct >= 100 ? 'bg-red-500' : pct >= 90 ? 'bg-amber-500' : 'bg-[#8CC774]');

export const LesseeLeaseCard = ({ vehicleId, el }) => {
    const [info, setInfo] = useState(null);

    useEffect(() => {
        api.get(`/leasing/lease-info/${vehicleId}`).then((res) => setInfo(res.data)).catch(() => setInfo(null));
    }, [vehicleId]);

    if (!info) return null;
    const loc = el ? 'el-GR' : 'en-GB';
    const expired = info.days_left !== null && info.days_left < 0;
    const soon = info.days_left !== null && info.days_left <= 30;

    return (
        <div className="fleet-card p-5 border-l-4 border-amber-500" data-testid="lessee-lease-card">
            <div className="flex items-center gap-2 mb-4">
                <Handshake className="w-5 h-5 text-amber-600" />
                <h2 className="text-base md:text-lg font-semibold text-slate-800">{el ? 'Σύμβαση Leasing' : 'Leasing contract'}</h2>
                <span className="text-sm text-slate-500">- {info.leasing_company_name}</span>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="flex items-start gap-3">
                    <CalendarClock className={`w-5 h-5 mt-0.5 ${soon ? 'text-red-600' : 'text-slate-400'}`} />
                    <div>
                        <p className="text-xs uppercase tracking-wide text-slate-500">{el ? 'Λήξη σύμβασης' : 'Contract end'}</p>
                        <p className="text-lg font-semibold text-slate-800" data-testid="lessee-lease-end">{info.contract_end_date ? new Date(info.contract_end_date).toLocaleDateString(loc) : '-'}</p>
                        {info.days_left !== null && (
                            <p className={`text-sm ${soon ? 'text-red-600 font-medium' : 'text-slate-500'}`} data-testid="lessee-lease-days-left">
                                {expired ? (el ? `Έληξε πριν ${-info.days_left} ημέρες` : `Expired ${-info.days_left} days ago`) : (el ? `Απομένουν ${info.days_left} ημέρες` : `${info.days_left} days left`)}
                            </p>
                        )}
                    </div>
                </div>
                <div className="flex items-start gap-3">
                    <Gauge className={`w-5 h-5 mt-0.5 ${info.km_percent >= 90 ? 'text-red-600' : 'text-slate-400'}`} />
                    <div className="flex-1">
                        <p className="text-xs uppercase tracking-wide text-slate-500">{el ? 'Όριο χιλιομέτρων' : 'Km limit'}</p>
                        {info.km_limit ? (
                            <>
                                <p className="text-lg font-semibold text-slate-800" data-testid="lessee-lease-km-remaining">
                                    {info.km_remaining >= 0
                                        ? `${info.km_remaining.toLocaleString(loc)} km ${el ? 'απομένουν' : 'remaining'}`
                                        : `${(-info.km_remaining).toLocaleString(loc)} km ${el ? 'υπέρβαση' : 'over limit'}`}
                                </p>
                                <div className="h-2 bg-slate-100 rounded-full mt-2 overflow-hidden">
                                    <div className={`h-full ${barColor(info.km_percent)}`} style={{ width: `${Math.min(info.km_percent, 100)}%` }} />
                                </div>
                                <p className="text-xs text-slate-500 mt-1">{info.current_mileage.toLocaleString(loc)} / {info.km_limit.toLocaleString(loc)} km ({info.km_percent}%)</p>
                            </>
                        ) : <p className="text-lg font-semibold text-slate-800">-</p>}
                    </div>
                </div>
            </div>
        </div>
    );
};
